import { Select } from 'tea-component';
import React, {useEffect, useMemo, useState} from 'react';
import { NUMBER_OPERATION_OPTIONS } from '@dbl/core/filter';
import { EntryProps } from '../interface';
import { checkNullString } from '@/pages/datalab/utils/utils';

import { NumberInput } from '../widgets/NumberInput';

const NumberOptions = NUMBER_OPERATION_OPTIONS.slice(0, NUMBER_OPERATION_OPTIONS.length - 1);
const BETWEEN = 'between';
export const FilterNumberEntry = (props: EntryProps) => {
  const { column, onChange, isEn } = props;
  const [operation, setOperation] = useState(
    !checkNullString(column.operation) ? column.operation : NumberOptions[0].value,
  );
  const [numberValue, setNumberValue] = useState<any[]>(column.column_value ?? []);

  useEffect(() => {
    onChange(operation, operation === BETWEEN ? numberValue : [numberValue[0]]);
  }, [JSON.stringify(numberValue), operation]);
  const localeOptions = useMemo(() => NumberOptions.map((opt)=> ({value: opt.value, text: isEn ? opt.text_en : opt.text})), [isEn]);
  return (
    <>
      <Select
        className="fs-entry-string-operation"
        appearance="button"
        options={localeOptions}
        value={operation}
        onChange={(value) => {
          if (value === operation) {
            return;
          }
          setOperation(value);
        }}
      />
      <NumberInput
        className="fs-entry-string-values"
        between={operation === BETWEEN}
        numberValues={numberValue}
        onChange={(values: any[]) => {
          setNumberValue(values);
        }}
        isEn={isEn}
      />
    </>
  );
};
